import { faqs } from "./json-ld";

export default function FaqSection() {
  return (
    <section id="faq" className="scroll-mt-8">
      <h2 className="text-2xl font-bold tracking-tight mb-6">
        Veelgestelde vragen
      </h2>
      <dl className="space-y-6">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b pb-6 last:border-b-0">
            <dt className="text-lg font-semibold mb-2">{faq.question}</dt>
            <dd className="text-muted-foreground">{faq.answer}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
